import { CONTRACTOR_CLIENTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/contractor_clients_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'supplierCustomersIndex',
	'contractorLocationsDropdown',
	'WORK_ORDER_CREATION_AUTOCOMPLETE',
	'workOrdersAdvancedFilters',
	'CONTRACTOR_WO_EDIT_AUTOCOMPLETE',
	'locationsAdvancedFiltersIndes',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
